import React from 'react'
import UserAuthCallback from '../../components/UserAuthCallback/UserAuthCallback.jsx'

export default function UserAuthCallbackPage() {
  return (
    <UserAuthCallback/>
  )
}
